import React, { useState } from 'react';
import Form, { TextInput, SelectInput } from 'packages/form';
import { history, clearResourceCache } from 'app';
import sweetNotification from 'packages/ui/sweetNotification';
import Button from 'packages/ui/Button';

const payment_status = ['all', 'paid', 'pending', 'canceled'];

export default () => {
  const [paymentStatus, setPaymentStatus] = useState(payment_status[0]);

  const handleSubmit = async data => {
    let searchQuery;
    if (Object.entries(data).length === 0) {
      sweetNotification({
        description: 'هیچ گزینه ای برای جستجو انتخاب نکرده اید'
      });
    } else {
      searchQuery = Object.entries(data).map(([key, val]) => `${key}=${val}&`);
      clearResourceCache('ads', 'collection');
      return searchQuery;
    }
  };

  return (
    <Form
      name="vando-search"
      onSubmit={data =>
        handleSubmit(data).then(searchQuery => {
          window.location.href = `/ads?${searchQuery}`;
        })
      }
    >
      <TextInput label="آی دی رویداد" name="event_id" />

      <SelectInput
        label="وضعیت سفارش"
        name="transactionStatus"
        value={paymentStatus}
        onChange={e => setPaymentStatus(e.target.value)}
      >
        {payment_status.map(item => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </SelectInput>

      <Button type="submit">جستجو</Button>
    </Form>
  );
};
